import { render, staticRenderFns } from "./DialogEditSortNum.vue?vue&type=template&id=7f8922c1&"
import script from "./DialogEditSortNum.vue?vue&type=script&lang=js&"
export * from "./DialogEditSortNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports